{
  "update": "Доступна новая версия CloudServer.",
  "reload": "Обновить"
}
